import { $ } from '@/libs/jquery/index'

$.validator.addMethod('address', function(value: string, element: HTMLElement): boolean {
  const isCorrect: boolean = (/[^!@#\$%\^&\*\+<>\|\{\}\[\]]+$/i)
    .test(value)

  return this.optional(element) || isCorrect
}, 'Адрес заполнен некорректно')
